export default __webpack_public_path__ + "static/media/box.0185ef15.jpg";